import { NgClass } from '@angular/common';
import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { FontIconComponent } from '@camelot/icons';

@Component({
  host: { 'data-cid': 'grid-ref-header-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  styleUrl: './ref-header.component.scss',
  templateUrl: './ref-header.component.html',
  imports: [FontIconComponent, NgClass],
})
export class GridRefHeaderCellComponent extends AbstractCellComponent<unknown, string, { _children: number }> {
  get haveChildren() {
    return this._data?._children ?? 0 > 0;
  }
  get isExpanded() {
    return this.params.node.expanded ?? false;
  }
  override agInit(params: any) {
    super.agInit(params);
    this.value = params.innerRenderer(params);
  }

  toggle() {
    this.params.api.setRowNodeExpanded(this.params.node, !this.params.node.expanded);
  }

  getClasses() {
    return { ['level-' + this.params.node.level]: true };
  }
}
